import { useMutation } from "@tanstack/react-query";
import api from "apis";

export const useRemoveTempDocumentMutation = () => {
  return useMutation({ mutationFn: api.document.deleteDocumentTemp });
};
